module.exports = __webpack_public_path__ + "static/media/bbpos_swipe_insert_tap.6d07e7a6.png";